export const SET_LOGINUSER = 'SET_LOGINUSER'
export const REMOVE_LOGINUSER = 'REMOVE_LOGINUSER'

export const SET_ADMIN = 'SET_ADMIN'
export const REMOVE_ADMIN = 'REMOVE_ADMIN'

export const SWITCH_COLLASPED = 'SWITCH_COLLASPED'
export const SWITCH_CURRENT_MENU = 'SWITCH_CURRENT_MENU'

export const SWITCH_DRAWER = 'SWITCH_DRAWER'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js